import { render, staticRenderFns } from "./FactMixin.vue?vue&type=template&id=132c6f51&"
import script from "./FactMixin.vue?vue&type=script&lang=ts&"
export * from "./FactMixin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports